<template>
  <nav class="bottom-nav">
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'express' }"
      @click="navigateTo('express')"
    >
      <div class="nav-icon-wrapper">
        <div class="nav-circle" :class="{ active: activeTab === 'express' }"></div>
        <i class="material-icons">timer</i>
      </div>
      <span>VisiónExpress</span>
    </div>
    
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'tendencia' }"
      @click="navigateTo('tendencia')"
    >
      <div class="nav-icon-wrapper">
        <div class="nav-circle" :class="{ active: activeTab === 'tendencia' }"></div>
        <i class="material-icons">whatshot</i>
      </div>
      <span>Tendencia</span>
    </div>
    
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'home' }"
      @click="navigateTo('home')"
    >
      <div class="nav-icon-wrapper">
        <div class="nav-circle" :class="{ active: activeTab === 'home' }"></div>
        <i class="material-icons">home</i>
      </div>
      <span>Portada</span>
    </div>
    
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'radio' }"
      @click="navigateTo('radio')"
    >
      <div class="nav-icon-wrapper">
        <div class="nav-circle" :class="{ active: activeTab === 'radio' }"></div>
        <i class="material-icons">radio</i>
      </div>
      <span>Radio</span>
    </div>
    
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'mizona' }"
      @click="navigateTo('mizona')"
    >
      <div class="nav-icon-wrapper">
        <div class="nav-circle" :class="{ active: activeTab === 'mizona' }"></div>
        <i class="material-icons">person</i>
      </div>
      <span>Mi Zona</span>
    </div>
  </nav>
  <!-- MODAL PREMIUM -->
    <div v-if="showPremiumModal" class="modal-overlay">
      <div class="modal">
        <div class="modal-icon">🔒</div>

        <h2>Acceso restringido</h2>
        <p>{{ modalMessage }}</p>

        <button class="modal-btn" @click="showPremiumModal = false">
          Aceptar
        </button>
      </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'
import api from '@/services/api'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const activeTab = ref('home')

onMounted(async () => {
  const token = localStorage.getItem('auth_token')

  if (token && !authStore.user) {
    try {
      const res = await api.get('/app/user')
      authStore.user = res.data.user
    } catch (e) {
      console.error('Error cargando usuario en BottomNav', e)
      authStore.user = null
    }
  }
})

// 🔥 MODAL
const showPremiumModal = ref(false)
const modalMessage = ref('')

// actualizar tab activo
const updateActiveTab = () => {
  const path = route.path

  if (path === '/' || path === '/home') {
    activeTab.value = 'home'
  } else if (path.includes('/express')) {
    activeTab.value = 'express'
  } else if (path.includes('/tendencia')) {
    activeTab.value = 'tendencia'
  } else if (path.includes('/radio')) {
    activeTab.value = 'radio'
  } else if (path.includes('/mizona')) {
    activeTab.value = 'mizona'
  }
}

watch(() => route.path, () => {
  updateActiveTab()
}, { immediate: true })

// 🔥 VALIDAR PREMIUM
const isPremium = () => {
  return authStore.user && authStore.user.is_premium === true
}

// navegación con control premium
const navigateTo = (tab) => {
  let path = '/home'

  if (tab === 'tv' || tab === 'radio' || tab === 'express') {
    if (!isPremium()) {
      modalMessage.value = 'Este contenido es exclusivo para usuarios Premium'
      showPremiumModal.value = true
      return
    }
  }

  switch (tab) {
    case 'home': path = '/home'; break
    case 'express': path = '/express'; break
    case 'tendencia': path = '/tendencia'; break
    case 'radio': path = '/radio'; break
    case 'mizona': path = '/mizona'; break
  }

  router.push(path)
}
</script>


<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 12px 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  border-top: 1px solid #eee;
  z-index: 1000;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  cursor: pointer;
  padding: 8px 0 4px;
  border-radius: 8px;
  position: relative;
}

.nav-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.nav-circle {
  position: absolute;
  width: 0px;
  height: 0px;
  background: white;
  border-radius: 50%;
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.5, 1);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  box-shadow: none;
  z-index: 0;
}

.nav-circle.active {
  width: 56px;
  height: 56px;
  opacity: 1;
  top: -18px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.02);
}

.nav-icon-wrapper i {
  position: relative;
  font-size: 24px;
  color: #888;
  transition: all 0.3s ease;
  z-index: 1;
}

.nav-item.active .nav-icon-wrapper i {
  color: #a50000;
  transform: translateY(-30px);
}

.nav-item span {
  font-size: 10px;
  color: #888;
  transition: all 0.2s ease;
}

.nav-item.active span {
  color: #a50000;
  font-weight: 600;
}

/* Efecto hover */
.nav-item:hover .nav-icon-wrapper i {
  color: #a50000;
}

.nav-item:hover span {
  color: #666;
}

/* Animación al hacer clic */
.nav-item:active .nav-circle.active {
  transform: translate(-50%, -50%) scale(1.05);
  transition: all 0.1s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .bottom-nav {
    padding: 6px 8px 14px;
  }
  
  .nav-icon-wrapper i {
    font-size: 22px;
  }
  
  .nav-circle.active {
    width: 60px;
    height: 60px;
    top: -15px;
  }
  
  .nav-item.active .nav-icon-wrapper i {
    transform: translateY(-27px);
  }
  
  .nav-item span {
    font-size: 9px;
  }

  .nav-item.active span {
        color: #a50000;
        font-weight: 600;
    }
}

@media (max-width: 480px) {
  .nav-icon-wrapper i {
    font-size: 20px;
  }
  
  .nav-circle.active {
    width: 60px;
    height: 60px;
    top: -12px;
  }
  
  .nav-item.active .nav-icon-wrapper i {
    transform: translateY(-22px);
  }
  
  .nav-item span {
    font-size: 8px;
  }

  .nav-item.active span {
    color: #a50000;
    font-weight: 600;
    }

}

/* =========================
   MODAL OVERLAY
========================= */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
}

/* =========================
   MODAL BOX
========================= */
.modal {
  background: #fff;
  width: 100%;
  max-width: 320px;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  animation: pop 0.25s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

/* icono */
.modal-icon {
  font-size: 40px;
  margin-bottom: 10px;
}

/* título */
.modal h2 {
  font-size: 16px;
  margin-bottom: 8px;
  color: #111;
}

/* texto */
.modal p {
  font-size: 13px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.4;
}

/* botón */
.modal-btn {
  background: #00144a;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s ease;
}

.modal-btn:hover {
  background: #002a8a;
}

/* animación entrada */
@keyframes pop {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

</style>